import { render, staticRenderFns } from "./FormDataTable.vue?vue&type=template&id=6b9d2380&"
import script from "./FormDataTable.vue?vue&type=script&lang=js&"
export * from "./FormDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormDataTable.vue"
export default component.exports